// @flow
import React from 'react';
import './FilePreview.css';
import {apiBase} from '../../helpers/request';

const fileUrl = `${apiBase}/files`;

export type Props = {
  file?: any,
  previewSize?: any,
  onClickEmpty?: Function,
};

const FilePreview = ({file, previewSize = {w: 440, h: 148}, onClickEmpty}: Props) => (
  <div className="FilePreview">
    {!file &&
      <div className="no-image" onClick={() => onClickEmpty && onClickEmpty()}>
        <i className="fa fa-file-image-o" />
      </div>
    }
    {file &&
      <img
        src={`${fileUrl}/preview/${file.id}/${previewSize.w}x${previewSize.h}`}
        alt="" />
    }
  </div>
);

export default FilePreview;



// WEBPACK FOOTER //
// ./src/components/FilePreview/FilePreview.js